import { apiClient } from '../../config/axios.config';
import { BASE_URL, BASE_LOAN_URL, CODE_LIST_URL } from '../apiConfig';

const fetchEmployeeLoanEnquiry = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LOAN_URL}/get-list`,
    payload,
  );
  return response;
};

const applyLoan = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LOAN_URL}/apply`,
    payload,
  );
  return response.result;
};

const fetchCodeList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${CODE_LIST_URL}`,
    payload,
  );
  return response.result;
};

const fetchLoanById = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LOAN_URL}/get-details`,
    payload,
  );
  return response.result;
};

// Fetch Outstanding Loan details
const fetchOutstandingLoanData = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_LOAN_URL}/outstanding`,
  );
  return response;
};

export {
  fetchEmployeeLoanEnquiry,
  applyLoan,
  fetchCodeList,
  fetchLoanById,
  fetchOutstandingLoanData,
};
